export enum FormFieldType {

    // Deal form
    SymbolId = "SymbolId",
    Amount = "Amount",
    MinAmount = "MinAmount",
    OrderRate = "OrderRate",
    PositionDirection = "PositionDirection",
    RateRequestType = "RateRequestType",
    StopLossChecked = "StopLossChecked",
    StopLossValueRate = "StopLossValueRate",
    StopLossValueAmount = "StopLossValueAmount",
    TakeProfitChecked = "TakeProfitChecked",
    TakeProfitValueRate = "TakeProfitValueRate",
    TakeProfitValueAmount = "TakeProfitValueAmount",
    ExpirationChecked = "ExpirationChecked",
    ExpirationDay = "ExpirationDay",
    ExpirationMonth = "ExpirationMonth",
    ExpirationYear = "ExpirationYear",
    Reason = "Reason",
    TakeProfit = "TakeProfit",
    StopLoss = "StopLoss",
    CurrentPassword = "CurrentPassword",
    NewPassword = "NewPassword",
    ConfirmPassword = "ConfirmPassword",
    CloseOutMethod = "CloseOutMethod",
    CloseOutChecked = "CloseOutChecked",
    MyLeverageValue = "MyLeverageValue",
    MyLeverageChecked = "MyLeverageChecked",
    AnnualStatementYear = "AnnualStatementYear",
    Price = "Price",
    PriceType = "PriceType",
    NotifyByEmail = "NotifyByEmail",
    NotifyByPushNotifications = "NotifyByPushNotifications",
    Recuring = "Recuring",
    PriceDirection = "PriceDirection",
    Email = "Email",
    PhoneNumber = "PhoneNumber",
    PnoneNumberCountryCode = "PnoneNumberCountryCode"
}
